export const APP_NAME = 'skymiles-landing-page';
export const TRACKJSCONFIG = [
  {
    name: 'dvl1.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-mnx-skymiles-lp'
  },
  {
    name: 'dvl2.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-mnx-skymiles-lp'
  },
  {
    name: 'dvl3.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-mnx-skymiles-lp'
  },
  {
    name: 'st.delta.com',
    token: '155b41f470444545829ee11dc1cb03ff',
    application: 'qat-mnx-skymiles-lp'
  },
  {
    name: 'si.delta.com',
    token: '7749d424d31d404288ad07069d2775c9',
    application: 'si-mnx-skymiles-lp'
  },
  {
    name: 'www.delta.com',
    token: '40c5d1df6a8049dfa571d3e4324bef72',
    application: 'www-mnx-skymiles-lp'
  }
];
